// Capacitor retains its launch intent across WebView reloads. Session storage
// survives logout's localStorage wipe, but ends with this WebView/tab session.
const HANDLED_KEY = "ds_native_handled_links";
const LOGOUT_KEY = "ds_native_skip_launch_after_logout";

const handledPaths = () => {
  try {
    const paths = JSON.parse(sessionStorage.getItem(HANDLED_KEY) || "[]");
    return new Set(Array.isArray(paths) ? paths : []);
  } catch {
    return new Set();
  }
};

export const rememberNativeLink = (path) => {
  if (!path) return;
  try {
    const paths = handledPaths();
    paths.add(path);
    sessionStorage.setItem(HANDLED_KEY, JSON.stringify([...paths]));
  } catch {
    // A live URL event can still navigate when storage is unavailable.
  }
};

export const skipNativeLaunchAfterLogout = () => {
  try {
    sessionStorage.setItem(LOGOUT_KEY, "1");
  } catch {
    // Best effort on browsers where storage is unavailable.
  }
};

/** Only startup snapshots are deduplicated; a fresh appUrlOpen is user intent. */
export const claimNativeLaunchLink = (path) => {
  let afterLogout = false;
  try {
    afterLogout = sessionStorage.getItem(LOGOUT_KEY) === "1";
    sessionStorage.removeItem(LOGOUT_KEY);
  } catch {
    // Keep normal fresh-link handling when storage is unavailable.
  }
  const alreadyHandled = handledPaths().has(path);
  rememberNativeLink(path);
  return Boolean(path) && !afterLogout && !alreadyHandled;
};
